const BUILD_ENV = import.meta.env.VITE_APP_ENV || "prod";

const _FB_PROD = {
  apiKey: "AIzaSyDjDtyb09Vga1f_jaMDX0H1VuHwXcV82gs",
  authDomain: "contas-lar.firebaseapp.com",
  projectId: "contas-lar",
  storageBucket: "contas-lar.firebasestorage.app",
  messagingSenderId: "551024136872",
  appId: "1:551024136872:web:b3f9ab8cc879b682d3e89d",
};
const _FB_TEST = {
  apiKey: "AIzaSyAKMeShYL-MjwWrxKe-y8nMb8B0ykrimvM",
  authDomain: "contas-lar56.firebaseapp.com",
  projectId: "contas-lar56",
  storageBucket: "contas-lar56.firebasestorage.app",
  messagingSenderId: "306803758002",
  appId: "1:306803758002:web:fa2cbf8546ce7c1049caab",
};

// ── Hash helper (used internally for seed data) ───────────────
function h(s) {
  let x = 0;
  for (let i = 0; i < s.length; i++) {
    x = (x << 5) - x + s.charCodeAt(i);
    x |= 0;
  }
  return "h" + Math.abs(x).toString(36);
}

// ── Defaults ──────────────────────────────────────────────────
export const DEF_EXP = [
  { id: "moradia", label: "Moradia", color: "#4A7FB5", icon: "🏠" },
  { id: "alimentacao", label: "Alimentação", color: "#5A8A3A", icon: "🛒" },
  { id: "transporte", label: "Transporte", color: "#8A6A1A", icon: "🚗" },
  { id: "saude", label: "Saúde", color: "#8A3A3A", icon: "❤️" },
  { id: "lazer", label: "Lazer", color: "#5A4A8A", icon: "🎉" },
  { id: "educacao", label: "Educação", color: "#2A7A5A", icon: "📚" },
  { id: "vestuario", label: "Vestuário", color: "#7A3A5A", icon: "👗" },
  { id: "outros_exp", label: "Outros", color: "#6A6A6A", icon: "📦" },
];
export const DEF_INC = [
  { id: "salario", label: "Salário fixo", color: "#5A8A3A", icon: "💼" },
  { id: "freelancer", label: "Freelancer", color: "#4A7FB5", icon: "💻" },
  { id: "outros_inc", label: "Outros", color: "#6A6A6A", icon: "📦" },
];
export const DEF_NEW_USERS = [
  { name: "Pessoa 1", color: "#4A7FB5", bg: "#EAF0F8" },
  { name: "Pessoa 2", color: "#8A3A5A", bg: "#F8EAF0" },
  { name: "Casa", color: "#6A6A6A", bg: "#F0F0F0" },
];
export const DEF_AUSERS = ["Fau", "Rhay", "Familia", "Cachorras", "Helena"];
export const DEF_UC = {
  Fau: "#185FA5",
  Rhay: "#993556",
  Familia: "#1D9E75",
  Cachorras: "#BA7517",
  Helena: "#7F77DD",
};
export const DEF_UB = {
  Fau: "#E6F1FB",
  Rhay: "#FBEAF0",
  Familia: "#E6F6F1",
  Cachorras: "#FBF3E6",
  Helena: "#F0EFF9",
};

// ── Seed accounts & users ─────────────────────────────────────
export const SA_ALL = [
  {
    id: "acc-prod",
    name: "Finanças do Lar",
    projectId: "contas-lar",
    label: "Produção",
    active: true,
    blocked: false,
    createdAt: "2024-01-01",
    userIds: ["usr-fau", "usr-rhay"],
    firebaseConfig: JSON.stringify(_FB_PROD),
  },
  {
    id: "acc-test",
    name: "Homolog",
    projectId: "contas-lar56",
    label: "Teste",
    active: true,
    blocked: false,
    createdAt: "2024-06-01",
    userIds: ["usr-teste"],
    firebaseConfig: JSON.stringify(_FB_TEST),
  },
];
export const SA =
  BUILD_ENV === "test" ? SA_ALL.filter((a) => a.id === "acc-test") : SA_ALL;
export const SU = [
  {
    id: "usr-fau",
    name: "Fau",
    cpf: "43035287813",
    email: "fabio.email9@gmail.com",
    isAdmin: true,
    active: true,
    blocked: false,
    tempPassword: h("Atitude10!"),
    password: h("Atitude10!"),
    hasSetOwnPassword: true,
    accountIds: ["acc-prod"],
    createdAt: "2024-01-01",
  },
  {
    id: "usr-rhay",
    name: "Rhay",
    cpf: "48761570818",
    active: true,
    blocked: false,
    tempPassword: h("Atitude10!"),
    password: h("Atitude10!"),
    hasSetOwnPassword: true,
    accountIds: ["acc-prod"],
    createdAt: "2024-01-01",
  },
  {
    id: "usr-teste",
    name: "Teste",
    cpf: "00000000000",
    active: true,
    blocked: false,
    tempPassword: h("fauteste123"),
    password: h("fauteste123"),
    hasSetOwnPassword: false,
    accountIds: ["acc-test"],
    createdAt: "2024-06-01",
  },
];

// ── In-memory store ───────────────────────────────────────────
export const _store = {
  accounts: SA.map((a) => ({ ...a })),
  users: SU.map((u) => ({ ...u })),
};
export const storeGet = (col) => _store[col].map((x) => ({ ...x }));
export const storeSave = (col, id, dat) => {
  const i = _store[col].findIndex((x) => x.id === id);
  if (i >= 0) _store[col][i] = { ...dat };
  else _store[col].push({ ...dat });
};
export const storeDel = (col, id) => {
  _store[col] = _store[col].filter((x) => x.id !== id);
};
